import React, { PropTypes } from 'react'
import moment from 'moment-timezone'

import './DateSelector.scss'
import Day from './components/Day'
import CalendarDay from './components/CalendarDay'
import { HORIZON_DAYS } from '@src/globals'

const DateSelector = (props) => {
  const {
    input: {
      value,
      onChange
    },
    meta: {
      touched,
      error,
      pristine,
      dirty
    },
    startDate,
    days
  } = props

  const renderDays = (start, count) => {
    const result = []
    for (let i = 0; i < count; i++) {
      const date = start.clone().add(i, 'days')
      result.push(
        <Day
          key={i}
          date={date}
          selected={date.isSame(value, 'day')}
          onClick={onChange.bind(null, date)}
          />
      )
    }

    return result
  }

  const renderCalendar = () => {
    return (
      <CalendarDay
        selectedDate={value}
        onChange={onChange}
        minDate={startDate.clone().add(days, 'days')}
        maxDate={startDate.clone().add(HORIZON_DAYS, 'days')}
        />
    )
  }

  return (
    <div className='DateSelector'>
      <div className='DateSelector-days'>
        <div>
          {renderDays(startDate, days)}
          {renderCalendar()}
        </div>
      </div>
      <div className='DateSelector-error'>
        {
          touched && pristine &&
            'Debes elegir un día para tu servicio'
        }
        {
          touched && dirty && error &&
            <p>{error}</p>
        }
      </div>
    </div>
  )
}

DateSelector.displayName = 'DateSelector'
DateSelector.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }),
  startDate: PropTypes.object,
  days: PropTypes.number
}
DateSelector.defaultProps = {
  startDate: moment.tz('America/Mexico_City').startOf('day'),
  days: 7
}

export default DateSelector



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/DateTimeForm/components/DateSelector/DateSelector.js